import React from "react";

import ContentNotFoundErrorBoundary from "@/content/utils/content-not-found-error-boundary";

import { UniformEntryLazyPageProps } from "../../../../pages/uniform-entry/uniform-entry-lazy-page";
import { UniformWrapperLazy } from "../../../../uniform/uniform-wrapper-lazy";

export const UniformEntryLazyPageTemplate: React.FC<
    UniformEntryLazyPageProps
> = ({ composition, isUniformPlayground }) => {
    return (
        <ContentNotFoundErrorBoundary>
            <UniformWrapperLazy
                composition={composition}
                isUniformPlayground={isUniformPlayground}
            />
        </ContentNotFoundErrorBoundary>
    );
};
